import React, { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const CHUNK_SIZE = 4 * 1024 * 1024;

export default function EnvoiVideo() {
  const [code, setCode] = useState("");
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  const upload = async () => {
    if (!code || !file) { setStatus("Entrez le code et choisissez un fichier."); return; }
    setBusy(true);
    setStatus("Envoi en cours…");
    const uploadId = `${Date.now()}`;
    try {
      const total = Math.ceil(file.size / CHUNK_SIZE);
      for (let i = 0; i < total; i++) {
        const blob = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
        const fd = new FormData();
        fd.append("code", code);
        fd.append("upload_id", uploadId);
        fd.append("index", i);
        fd.append("chunk", blob, "chunk");
        await axios.post(`${API}/api/upload-video/chunk`, fd);
        setProgress(Math.round(((i + 1) / total) * 90));
      }
      setStatus("Assemblage et mise en ligne…");
      const fd = new FormData();
      fd.append("code", code);
      fd.append("upload_id", uploadId);
      fd.append("filename", file.name);
      const res = await axios.post(`${API}/api/upload-video/finalize`, fd, { timeout: 600000 });
      setProgress(100);
      setStatus(`Vidéo en ligne ! (${(res.data.size / 1024 / 1024).toFixed(0)} Mo) Elle est maintenant visible dans la rubrique « En vidéo ».`);
    } catch (e) {
      setStatus(e.response?.status === 403 ? "Code d'accès invalide." : `Erreur : ${e.message}. Réessayez.`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg border border-slate-200 p-8">
        <h1 className="font-display text-2xl text-[#12495B]">Envoi de la vidéo</h1>
        <p className="text-sm text-[#4B5563] mt-1">Page privée — réservée à l'équipe de campagne.</p>
        <label className="block mt-6 text-sm font-semibold text-[#12495B]">Code d'accès</label>
        <input
          type="password"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          data-testid="upload-code-input"
          className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
          placeholder="Code d'accès"
        />
        <label className="block mt-4 text-sm font-semibold text-[#12495B]">Fichier vidéo (mp4, mov…)</label>
        <input
          type="file"
          accept="video/*"
          onChange={(e) => setFile(e.target.files[0])}
          data-testid="upload-file-input"
          className="mt-1 w-full text-sm"
        />
        {progress > 0 && (
          <div className="mt-4 h-2 bg-slate-200 rounded-full overflow-hidden">
            <div className="h-full bg-[#F5C518] transition-all duration-300" style={{ width: `${progress}%` }} />
          </div>
        )}
        {status && <p className="mt-3 text-sm text-[#12495B] font-medium" data-testid="upload-status">{status}</p>}
        <button
          onClick={upload}
          disabled={busy}
          data-testid="upload-submit-button"
          className="mt-6 w-full bg-[#12495B] text-[#F5C518] font-extrabold uppercase tracking-wide rounded-xl px-6 py-3 hover:bg-[#0E3A49] transition-colors duration-300 disabled:opacity-50"
        >
          {busy ? "Envoi en cours…" : "Envoyer la vidéo"}
        </button>
      </div>
    </div>
  );
}
